import moment from "moment";
import * as tables from "../constants/tables";

// clone an object, and copy any properties that are arrays by value
function clone(original) {
  const cloned = Object.assign({}, original);
  Object.keys(cloned).forEach((key) => {
    cloned[key] = Array.isArray(cloned[key])
      ? cloned[key].slice()
      : cloned[key];
  });
  return cloned;
}

function hasClass(el, className) {
  if (el.classList) return el.classList.contains(className);
  else
    return !!el.className.match(new RegExp("(\\s|^)" + className + "(\\s|$)"));
}
// function addClass(el, className) {
//     if (el.classList)
//       el.classList.add(className)
//     else if (!hasClass(el, className)) el.className += " " + className
//   }

function removeClass(el, className) {
  if (el.classList) el.classList.remove(className);
  else if (hasClass(el, className)) {
    var reg = new RegExp("(\\s|^)" + className + "(\\s|$)");
    el.className = el.className.replace(reg, " ");
  }
}

// this method uses a hashtable to find all uniq options in the array. item.data must be a string.
function uniq(input) {
  const seen = {};
  return input.filter((item) => {
    return seen.hasOwnProperty(item.data) ? false : (seen[item.data] = true);
  });
}

function createHash(input) {
  const hash = {};
  for (var i = 0, l = input.length; i < l; i++) {
    hash[input[i]] = true;
  }
  return hash;
}

function getFirstName(fullname) {
  // TODO update to support ' and - in names
  const regex = /^([A-Z][a-z]+)\s([A-Z][a-z]+)$/;
  const matches = fullname.match(regex);
  const firstName = matches[1];
  return firstName;
}

function getLastName(fullname) {
  // TODO update to support ' and - in names
  const regex = /^([A-Z][a-z]+)\s([A-Z][a-z]+)$/;
  const matches = fullname.match(regex);
  const lastName = matches[2];
  return lastName;
}
function groupBy(list, keyGetter) {
  const map = new Map();
  list.forEach((item) => {
    const key = keyGetter(item);
    const collection = map.get(key);
    if (!collection) {
      map.set(key, [item]);
    } else {
      collection.push(item);
    }
  });
  return map;
}

function filterByArary(options, filter) {
  // ~this.indexOf(a) is shorthand for this.indexOf(a) !== -1
  return options.filter((a) => {
    return ~filter.indexOf(a);
  });
}
function isEmpty(obj) {
  return Object.keys(obj).length > 0 && obj.constructor === Object;
}

function hasChanges(changesObj) {
  return (
    Object.keys(changesObj).length > 0 && changesObj.constructor === Object
  );
}

// simple array comparison. If noticable performance issues investigate improvement
// (no premature optimization)
function arrayHasChanged(original, test, field) {
  if (original.length !== test.length) {
    return true;
  }
  for (let i = 0; i < original.length; i++)
    if (original[i][field] !== test[i][field]) {
      return true;
    }
  return false;
}

function sortById(array) {
  return array.sort(function (a, b) {
    return a.id - b.id;
  });
}
function sortByDate(field, array) {
  return array.sort(function (a, b) {
    return new Date(b[field]) - new Date(a[field]);
  });
}
function sortByField(field, array, ascending) {
  return array.sort(function (a, b) {
    if (ascending) {
      return a[field] - b[field];
    }
    return b[field] - a[field];
  });
}
function sortByFieldWithNulls(array, field, ascending) {
  const sorted = array.sort((a, b) => {
    const left = a[field];
    const right = b[field];
    if (left == null) {
      return 1;
    } else if (right == null) {
      return -1;
    } else if (left === right) {
      return 0;
    } else if (ascending) {
      return left < right ? -1 : 1;
    } else if (!ascending) {
      return left < right ? 1 : -1;
    }
    return 0;
  });
  return sorted;
}
function getCurrentTimeInISO() {
  return moment(new Date()).format("YYYY-MM-DD[T]HH:mm:ss.SSS");
}
function getFileExtention(filepath) {
  const path_splitted = filepath.split(".");
  return path_splitted.pop();
}
function guid() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  return (
    s4() +
    s4() +
    "-" +
    s4() +
    "-" +
    s4() +
    "-" +
    s4() +
    "-" +
    s4() +
    s4() +
    s4()
  );
}
function getTableColour(table) {
  switch (table) {
    case tables.OPEN_COMPANY_MODAL:
    default:
      return "#283678";
  }
}

function airtableMultilineToHtml(text) {
  return text
    .replace(/>>/g, "\n")
    .replace(/\n{2,}/g, "\n\n")
    .replace(/^\s+/g, "")
    .replace(
      /https?:\/\/\S+/g,
      (match) => `<a href=${match} target="_blank">${match}</a>`
    );
}

const utils = {
  airtableMultilineToHtml,
  clone,
  arrayHasChanged,
  createHash,
  filterByArary,
  getFileExtention,
  getCurrentTimeInISO,
  getFirstName,
  getLastName,
  getTableColour,
  guid,
  groupBy,
  hasChanges,
  hasClass,
  // addClass,
  removeClass,
  isEmpty,
  sortById,
  sortByDate,
  sortByField,
  sortByFieldWithNulls,
  uniq,
};

export default utils;



// WEBPACK FOOTER //
// ./src/services/utils.service.js